import { render, staticRenderFns } from "./pai.vue?vue&type=template&id=98df7eb0&scoped=true&"
import script from "./pai.vue?vue&type=script&lang=js&"
export * from "./pai.vue?vue&type=script&lang=js&"
import style0 from "./pai.vue?vue&type=style&index=0&id=98df7eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98df7eb0",
  null
  
)

export default component.exports